module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('g', [_c('defs', [_c('circle', {
    attrs: {
      "id": "a",
      "cx": "40",
      "cy": "40",
      "r": "40"
    }
  })]), _c('g', {
    attrs: {
      "fill": "none",
      "fill-rule": "evenodd"
    }
  }, [_c('mask', {
    attrs: {
      "id": "b",
      "fill": "#fff"
    }
  }, [_c('use', {
    attrs: {
      "xlink:href": "#a"
    }
  })]), _c('use', {
    attrs: {
      "fill": "#F9E9CB",
      "fill-rule": "nonzero",
      "xlink:href": "#a"
    }
  }), _c('g', {
    attrs: {
      "mask": "url(#b)",
      "fill-rule": "nonzero"
    }
  }, [_c('g', {
    attrs: {
      "transform": "translate(4.78 37.01)"
    }
  }, [_c('path', {
    attrs: {
      "fill": "#FEBE8C",
      "d": "M19.84 17.23l9.19-3.8h12.4l6.65 3.23v25.38H19.84z"
    }
  }), _c('path', {
    attrs: {
      "fill": "#E6B693",
      "d": "M28.96 47.87h12.62L43 40.39 41.95.3 35 .72h-7.26l.45 39.84z"
    }
  }), _c('path', {
    attrs: {
      "fill": "#FFF",
      "d": "M41.05 47.87l3.28-24.05L35 22.1l-9.04 1.8 2.7 23.98z"
    }
  }), _c('path', {
    attrs: {
      "d": "M59.33 47.87c.08-.59 2.9-25.96 2.9-25.96L46.7 15.28 34.88 47.87h24.45z",
      "fill": "#C73C3C"
    }
  }), _c('path', {
    staticStyle: {
      "mix-blend-mode": "multiply"
    },
    attrs: {
      "d": "M35.02 22.09a11.07 11.07 0 01-10.85-4.78l3.04 13.35c3.53-.9 6.42-3.42 7.81-6.78a12.18 12.18 0 007.82 6.76l3.05-13.35a11.07 11.07 0 01-10.87 4.8z",
      "fill": "#BFBFBF"
    }
  }), _c('path', {
    attrs: {
      "d": "M43.58 13.98c-.44.97-2.39 7.64-8.71 8.05 0 1.85 4.26 7.06 9.3 4.24C49.24 23.45 47 15.26 47 15.26l-3.42-1.28z",
      "fill": "#FFF"
    }
  }), _c('path', {
    attrs: {
      "d": "M26.5 13.96c.45.98 2.4 7.65 8.72 8.06 0 1.81-4.26 7.04-9.27 4.26-5.02-2.78-2.82-11.02-2.82-11.02l3.38-1.3z",
      "fill": "#FFF"
    }
  }), _c('path', {
    staticStyle: {
      "mix-blend-mode": "multiply"
    },
    attrs: {
      "d": "M38.91 47.87L53.1 29.13l-6.2-3.82a22.2 22.2 0 006.7-1.5c-1.03-4.61-6.9-8.53-6.9-8.53L34.96 47.87h3.95z",
      "fill": "#BFBFBF"
    }
  }), _c('path', {
    attrs: {
      "d": "M38.6 47.87c7.57-11.51 12.92-20.13 12.92-20.13l-4.62-2.4a24.84 24.84 0 014.62-2.65c-.69-6.45-4.77-8.36-4.77-8.36L34.8 47.76l3.8.1z",
      "fill": "#C73C3C"
    }
  }), _c('path', {
    attrs: {
      "d": "M11.24 47.87h23.7L23.14 15.28l-14.9 6.63S9.65 38.29 11 46.89c.1.32.17.65.24.98z",
      "fill": "#C73C3C"
    }
  }), _c('path', {
    staticStyle: {
      "mix-blend-mode": "multiply"
    },
    attrs: {
      "d": "M22.93 25.31l-5.62 3.76s5 7.03 13.73 18.8h3.38L22.7 15.75s-4.9 3.9-5.97 8.5c1.96.8 4.08 1.16 6.2 1.06z",
      "fill": "#BFBFBF"
    }
  }), _c('path', {
    attrs: {
      "d": "M18.71 27.46s5.17 8.8 12.6 20.4h3.7L23.07 14.59s-4.2 1.03-4.78 8.13c1.64.7 3.19 1.57 4.64 2.6l-4.22 2.15zM12.32 47.87L8.22 21.9S2.2 28.73 1.07 47.87h11.26zM58.13 47.87l4.1-25.96s5.96 6.82 7.16 25.96H58.13z",
      "fill": "#C73C3C"
    }
  }), _c('circle', {
    attrs: {
      "fill": "#9C6046",
      "cx": "35.02",
      "cy": "30.28",
      "r": "1.06"
    }
  }), _c('circle', {
    attrs: {
      "fill": "#9C6046",
      "cx": "35.02",
      "cy": "38.07",
      "r": "1.06"
    }
  })])]), _c('path', {
    attrs: {
      "d": "M57.44 48.87a68.98 68.98 0 01-18.18 2.8 46.63 46.63 0 01-16.25-2.88s3.58-3.06 1.28-16.58c-1.6-9.27 33.6-9.13 32.69.03-1.31 12.98.46 16.63.46 16.63z",
      "fill": "#5E3E1A",
      "fill-rule": "nonzero",
      "mask": "url(#b)"
    }
  }), _c('path', {
    attrs: {
      "d": "M36.93 52.02l1.27 1.04a2.3 2.3 0 004.15 0l.96-.98c.16-.71.25-1.44.27-2.17v-2.39a2.3 2.3 0 00-2.3-2.3h-2.13a2.3 2.3 0 00-2.3 2.3v2.3c-.05.73-.02 1.47.08 2.2z",
      "fill": "#E6B693",
      "fill-rule": "nonzero",
      "mask": "url(#b)"
    }
  }), _c('path', {
    staticStyle: {
      "mix-blend-mode": "multiply"
    },
    attrs: {
      "d": "M40.21 49.39c1.99 0 3.37-2.58 3.37-2.58v-1.6h-6.73v2.09c.76 1.15 2 1.9 3.36 2.09z",
      "fill": "#D0BBAC",
      "fill-rule": "nonzero",
      "mask": "url(#b)"
    }
  }), _c('path', {
    attrs: {
      "d": "M54.3 34.45c-2.05 8.82-10.81 13.79-14.12 13.8-3.3.01-10.91-4.25-13.74-13.62-1.4-4.67.37-6.88.37-12.35 0-7.49 5.9-12.56 13.26-12.56 7.76 0 14.21 4.56 14.23 12.56 0 4.96.52 9.96 0 12.17z",
      "fill": "#E6B693",
      "fill-rule": "nonzero",
      "mask": "url(#b)"
    }
  }), _c('path', {
    attrs: {
      "d": "M53.8 28.43a2.32 2.32 0 013.3-.85c1.56.73.9 6.08-.77 6.72-1.66.65-2.54-.17-2.54-.17M27.22 28.43a2.32 2.32 0 00-3.34-.85c-1.56.73-.88 6.08.76 6.72 1.65.65 2.55-.17 2.55-.17",
      "fill": "#E6B693",
      "fill-rule": "nonzero",
      "mask": "url(#b)"
    }
  }), _c('path', {
    attrs: {
      "d": "M31.68 27.46l.14-.2a3.58 3.58 0 012.11-1.4 2.66 2.66 0 011.86.28c.14.13 0 1.06-.17.96a5.09 5.09 0 00-1.67-.39 3.24 3.24 0 00-2.03.67l-.18.15-.06-.07zM49.17 27.16l-.14-.2a3.5 3.5 0 00-2.11-1.39 2.69 2.69 0 00-1.86.27c-.14.14 0 1.07.17.98.53-.24 1.1-.37 1.67-.4.54 0 1.07.11 1.55.35.18.09.34.2.48.32l.18.15c.04-.01.06-.04.06-.08z",
      "fill": "#5E3E1A",
      "fill-rule": "nonzero",
      "mask": "url(#b)"
    }
  }), _c('path', {
    attrs: {
      "d": "M47.58 31.63a.64.64 0 01-.68.58.63.63 0 01-.68-.58v-1.62a.63.63 0 01.68-.59c.35-.02.65.24.68.59v1.62z",
      "fill": "#3E2D1E",
      "fill-rule": "nonzero",
      "mask": "url(#b)"
    }
  }), _c('path', {
    attrs: {
      "d": "M47.33 30.44c0 .21-.1.38-.21.38-.12 0-.22-.17-.22-.38 0-.22.1-.37.22-.37s.21.16.21.37z",
      "fill": "#FFF",
      "fill-rule": "nonzero",
      "mask": "url(#b)"
    }
  }), _c('path', {
    attrs: {
      "d": "M35.04 31.63a.64.64 0 01-.68.58.63.63 0 01-.68-.58v-1.62a.63.63 0 01.68-.59c.35-.02.65.24.68.59v1.62z",
      "fill": "#3E2D1E",
      "fill-rule": "nonzero",
      "mask": "url(#b)"
    }
  }), _c('path', {
    attrs: {
      "d": "M34.88 30.44c0 .21-.1.38-.22.38s-.22-.17-.22-.38c0-.22.1-.37.22-.37.13 0 .22.16.22.37z",
      "fill": "#FFF",
      "fill-rule": "nonzero",
      "mask": "url(#b)"
    }
  }), _c('path', {
    staticStyle: {
      "mix-blend-mode": "multiply"
    },
    attrs: {
      "d": "M41.64 34.71c-.45-.14-.9-.21-1.37-.23-.35-.01-.7.07-1.01.23 0 0 .53-.87 1.2-.87.66 0 1.18.87 1.18.87z",
      "fill": "#D0BBAC",
      "fill-rule": "nonzero",
      "mask": "url(#b)"
    }
  }), _c('path', {
    attrs: {
      "d": "M43.94 40.24s-1.36 2.3-3.5 2.3c-1.7 0-3.5-2.3-3.5-2.3 1.15.2 2.3.35 3.47.43 1.18-.08 2.36-.22 3.53-.43z",
      "fill": "#BD2C30",
      "fill-rule": "nonzero",
      "mask": "url(#b)"
    }
  }), _c('path', {
    attrs: {
      "d": "M42.33 40.07c-.5-.12-.97-.35-1.37-.67-.12.25-.82.23-.91 0a5.1 5.1 0 01-3.1.81c1.12.39 2.3.6 3.5.65 1.18-.04 2.36-.26 3.49-.65-.54.01-1.08-.04-1.61-.14z",
      "fill": "#C73C3C",
      "fill-rule": "nonzero",
      "mask": "url(#b)"
    }
  }), _c('path', {
    staticStyle: {
      "mix-blend-mode": "multiply"
    },
    attrs: {
      "d": "M45.68 33.67c-.12 0-.12.14 0 .14s.12-.14 0-.14zM48.38 34.03c-.13 0-.13.14 0 .14s.12-.14 0-.14zM46.36 34.03c-.12 0-.12.14 0 .14s.14-.14 0-.14zM46.28 33.36c-.24 0-.24.29 0 .29s.29-.29 0-.29zM46 33.87c-.05 0-.05.08 0 .08.07 0 .08-.08 0-.08zM47.57 33.2c-.06 0-.06.08 0 .08s.06-.07 0-.07zM48.02 34.28c-.07 0-.07.07 0 .07.08 0 .06-.07 0-.07zM47.52 34v.07s.06-.08 0-.08zM46.71 33.78c-.17 0-.17.19 0 .19s.17-.2 0-.2zM47.15 33.5c-.2 0-.2.24 0 .24s.22-.24 0-.24zM47.06 33.16a.08.08 0 100 .15c.13 0 .13-.15 0-.15zM48.14 33.05c-.19 0-.19.23 0 .23.2 0 .2-.23 0-.23zM48.66 33.54c-.18 0-.18.2 0 .2s.18-.2 0-.2zM47.84 33.54c-.13 0-.22.06-.2.16 0 .1.22.13.31.06a.13.13 0 00-.1-.22zM47.13 34.15c-.29 0-.29.33 0 .33.28 0 .3-.33 0-.33zM32.74 33.72c-.13 0-.13.14 0 .14s.12-.14 0-.14zM35.44 34.08c-.13 0-.13.14 0 .14s.12-.14 0-.14zM33.43 34.08c-.12 0-.12.14 0 .14s.12-.14 0-.14zM33.34 33.43c-.24 0-.24.28 0 .28s.25-.28 0-.28zM33.06 33.92c-.06 0-.06.07 0 .07s.07-.07 0-.07zM35.08 34.33c-.07 0-.07.07 0 .07s.06-.07 0-.07zM34.63 34.04c-.06 0-.06.07 0 .07s0-.07 0-.07zM33.77 33.83c-.17 0-.17.19 0 .19.16 0 .16-.2 0-.2zM34.2 33.54c-.2 0-.2.25 0 .25.21 0 .22-.25 0-.25zM34.11 33.2c-.13 0-.13.16 0 .16s.13-.15 0-.15zM35.2 33.1c-.2 0-.2.23 0 .23s.2-.23 0-.23zM35.71 33.59c-.18 0-.18.2 0 .2s.18-.2 0-.2zM34.9 33.59c-.13 0-.23 0-.2.15 0 .11.21.12.3.06a.12.12 0 00-.1-.21zM34.19 34.2c-.3 0-.3.33 0 .33.28 0 .3-.33 0-.33z",
      "fill": "#D0BBAC",
      "fill-rule": "nonzero",
      "mask": "url(#b)"
    }
  }), _c('path', {
    attrs: {
      "d": "M56.24 34.8a1.13 1.13 0 11-2.26.24 1.13 1.13 0 012.26-.23z",
      "fill": "#009CDF",
      "fill-rule": "nonzero",
      "mask": "url(#b)"
    }
  }), _c('path', {
    attrs: {
      "d": "M55.27 35.49a1.2 1.2 0 01-1.12-1.14v-.16a1.2 1.2 0 00.94 1.81c.56 0 1.04-.41 1.11-.97-.21.3-.56.47-.93.46z",
      "fill": "#0083B9",
      "fill-rule": "nonzero",
      "mask": "url(#b)"
    }
  }), _c('path', {
    attrs: {
      "d": "M55.67 34.35a.56.56 0 11-.57-.51.54.54 0 01.57.51z",
      "fill": "#FFF",
      "fill-rule": "nonzero",
      "mask": "url(#b)"
    }
  }), _c('path', {
    staticStyle: {
      "mix-blend-mode": "multiply"
    },
    attrs: {
      "d": "M55.51 33.22c.14-.44.17-.91.07-1.36-.15-.58-.75-1-.71-1.2.08-.7.28-1.38.6-2.02.3-.39.82-.55 1.3-.4.5.75.74 1.66.67 2.57a3.9 3.9 0 00-.91-2.15c-.09-.09-.55 0-.86.53-.27.48-.48.98-.64 1.5-.08.22.98.27 1.13.84.14.58-.65 1.69-.65 1.69z",
      "fill": "#D0BBAC",
      "fill-rule": "nonzero",
      "mask": "url(#b)"
    }
  }), _c('path', {
    attrs: {
      "d": "M24.93 34.8a1.13 1.13 0 102.27.03 1.13 1.13 0 00-2.27-.02z",
      "fill": "#009CDF",
      "fill-rule": "nonzero",
      "mask": "url(#b)"
    }
  }), _c('path', {
    attrs: {
      "d": "M25.89 35.49a1.2 1.2 0 001.13-1.3c.12.18.2.4.2.62a1.13 1.13 0 11-2.25.16c.2.32.54.5.92.52z",
      "fill": "#0083B9",
      "fill-rule": "nonzero",
      "mask": "url(#b)"
    }
  }), _c('path', {
    attrs: {
      "d": "M25.5 34.35a.56.56 0 10.55-.51c-.29 0-.53.22-.55.51z",
      "fill": "#FFF",
      "fill-rule": "nonzero",
      "mask": "url(#b)"
    }
  }), _c('path', {
    staticStyle: {
      "mix-blend-mode": "multiply"
    },
    attrs: {
      "d": "M25.65 33.22c-.14-.44-.17-.91-.07-1.36.16-.58.76-1 .72-1.2a5.97 5.97 0 00-.6-2c-.3-.41-.82-.58-1.3-.4-.5.75-.74 1.65-.67 2.56.07-.8.39-1.56.91-2.16.08-.09.55 0 .86.53.27.48.48.98.64 1.5.08.22-.98.27-1.13.84-.14.58.64 1.69.64 1.69z",
      "fill": "#D0BBAC",
      "fill-rule": "nonzero",
      "mask": "url(#b)"
    }
  }), _c('path', {
    attrs: {
      "d": "M54.93 27.77c.58-.58 1.5-.66 2.18-.19 0 0 1.4-5.62.37-9.67-1.93-7.76-10.02-11.12-14.17-11.37-4.16-.25-13.38 1.13-13.97 6.06-4.78-1.47-6.12 3.58-6.3 6.29.03 2.92.32 5.82.84 8.7 0 0 .94-.52 1.2-.34 0 0-.52 5.9 3.22 8.55-1.86-2.9 2.04-7.9-.55-13.57 4.12-1.36 8.62 3.38 23.06 2.02.58 6.2 2.2 7.16 1.43 10.33 2.78-2.56 1.78-5.8 2.69-6.8z",
      "fill": "#5E3E1A",
      "fill-rule": "nonzero",
      "mask": "url(#b)"
    }
  }), _c('path', {
    attrs: {
      "d": "M47.62 27.32c-3.05 0-4.85.55-5.57 1.2a3.46 3.46 0 00-2.17-.6c-.48.05-.93.24-1.3.55-.75-.67-2.52-1.2-5.5-1.2-3.85 0-5.96 1.02-5.96 1.97 0 1.92.37 6.39 3.77 6.39s5.53-.68 6.83-2.02A5.22 5.22 0 0039 29.54v-.13c.22-.3.57-.5.95-.51a2.5 2.5 0 011.72.57v.07c-.17 1.5.3 3 1.32 4.12 1.3 1.34 3.58 2.02 6.82 2.02 3.25 0 3.78-4.47 3.78-6.39-.03-.96-2.1-1.97-5.97-1.97zm-10.6 5.65c-1.12 1.2-3.17 1.73-6.13 1.73-2.47 0-2.77-3.68-2.78-5.35.24-.3 1.74-1.05 4.95-1.05 3.72 0 4.85.82 4.95.99v.32a4.3 4.3 0 01-1 3.36zm12.77 1.73c-2.95 0-5.01-.59-6.11-1.73a4.3 4.3 0 01-1-3.36v-.26c.09-.23 1.19-1.05 4.94-1.05 3.22 0 4.71.75 4.97 1.05-.05 1.7-.32 5.35-2.8 5.35z",
      "fill": "#C6362E",
      "fill-rule": "nonzero",
      "mask": "url(#b)"
    }
  })])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-aec83346","hasScoped":false,"preserveWhitespace":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/profile/modules/mentoring/components/avatar/components/stub/components/woman/MentoringWomanIcon.vue
// module id = 70e6049a18c608626caa
// module chunks = 89